import * as types from '../mutation-types'

const deliveryMonth = {
  namespaced: true,
  state: {
    selectedDeliveryMonth: undefined
  },
  getters: {
    selectedDeliveryMonth: state => state.selectedDeliveryMonth
  },
  mutations: {
    [types.RECEIVE_COMMON_SELECT_DELIVERY_MONTH](state, selectedDeliveryMonth) {
      state.selectedDeliveryMonth = selectedDeliveryMonth
    }
  },
  actions: {
    setSelectedDeliveryMonth: function({ commit }, params) {
      commit(types.RECEIVE_COMMON_SELECT_DELIVERY_MONTH, params)
    },
    getMonthAllList: function({ commit }) {
      var monthList = initMonthList()
      monthList.unshift({
        label: `全て`,
        value: `000000`
      })
      return monthList
    },
    getMonthList: function({ commit }) {
      return initMonthList()
    },
    reset: function({ commit }) {
      commit(types.RECEIVE_COMMON_SELECT_DELIVERY_MONTH, undefined)
    }
  }
}
function initMonthList() {
  let monthList = []
  for (let cc = -1; cc < 24; ++cc) {
    let dt = new Date()
    // 月初に変更してから月を引く
    dt.setDate(1)
    dt.setMonth(dt.getMonth() - cc)
    monthList.push({
      label: `${dt.getFullYear()}/${('0' + (dt.getMonth() + 1)).slice(-2)}`,
      value: `${dt.getFullYear()}${('0' + (dt.getMonth() + 1)).slice(-2)}`
    })
  }
  return monthList
}

export default deliveryMonth
